export const EMPTY_POLYGON = 'https://acko-cms.ackoassets.com/Polygon_empty_a6a6dfbc06.svg'
export const FILLED_POLYGON = 'https://acko-cms.ackoassets.com/Polygon_filled_ce37f03593.svg'
export const VIDEO_NO_SUPPORT = 'Your browser does not support the video tag.'
export const IMAGE_MEDIA_REGEX = /\.(webp|svg|gif)$/
export const VIDEO_MEDIA_ENDING = '.mp4'
export const MUTE_AUDIO_ICON_SRC = 'https://acko-cms.ackoassets.com/Muted_ef9db539ec.svg'
export const UNMUTE_AUDIO_ICON_SRC = 'https://acko-cms.ackoassets.com/Unmuted_411ec8b0e4.svg'
